import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DashboardPage } from 'app/dashboard/components/dashboard-page/dashboard-page';
import { Dialog, DialogGroups } from 'app/dialogs';
import { DialogsService } from 'app/dialogs/services/dialogs.service';
import { UserProfile, UserRole } from 'app/profile/model/model';
import { UserService } from 'app/profile/services/user.service';

import * as moment from 'moment';

import {NavService} from 'shared/nav/nav.service';
import { DefaultMenuPage } from '../default-menu-page/default-menu-page';

@Component({
  selector: 'today-page',
  templateUrl: 'today-page.html',
  styleUrls: ['today-page.scss'],
})
export class TodayPage extends DefaultMenuPage implements OnInit {

  public newDialogsCount: number = 0;

  private _dialogs: Array<Dialog>;
  
  public lineY = '';

  constructor(
    public navService: NavService,
    private userService: UserService,
    private translateService: TranslateService,
    private dialogsService: DialogsService,
  ) {
    super(navService, translateService);
    if ( navService.get('lineY') !== undefined ) {
      this.lineY = (navService.get('lineY')-56-24)+'px'; // TODO: Header-Höhe und halbe Itemhöhe
      // console.log("## "+navService.get('lineY')+'px');
    }
  }

  public ngOnInit(): void {
    this.dialogsService.getDialogs()
      .subscribe((dialogs) => {
        this._dialogs = dialogs.filter(dia => dia.thesis === undefined);
        this.newDialogsCount = this._dialogs.length;
      });
  }

  public showDialogsPage(): void {
    const groups: DialogGroups = this._dialogs.reduce(DashboardPage.groupDialogsByDate, {});

    Object.keys(groups).forEach((key) => {
      groups[key].sort(DashboardPage.sortDialogsByDate);
    });
    this.navService.push('dialogs/list', { dialogs: groups });
  }

  public showReflectionsPage(type: number): void {
    this.navService.push('/insights');
  }

  public showMessagesPage(): void {
    ;//this.navService.push('profile/help');
  }

}
